<template>
  <div id="app">
    <MainMenu/>
    <div id="content">
      <div id="mainContent">
        <transition name="slide-down-fade" mode="out-in">
          <router-view/>
        </transition>
      </div>
      <Footer/>
    </div>
  </div>
</template>

<script>
import MainMenu from '@/components/Menu/MainMenu'
import Footer from '@/components/Footer'

window.$ = require('jquery')
window.JQuery = require('jquery')

export default {
  name: 'App',
  components: {
    MainMenu,
    Footer
  }
}
</script>

<style>
  body {
    margin: 0;
    overflow: hidden;
  }
  p, li {
    font-family: 'Roboto', sans-serif;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  #content {
    overflow-y: auto;
    height: calc(100vh - 92px);
    padding-top: 20px;
  }
  #mainContent {
    min-height: calc(100vh - 164px);
    padding-left: 10%;
    padding-right: 10%;
  }

  .slide-down-fade-enter-active, .slide-down-fade-leave-active {
    transition: all .5s;
  }
  .slide-down-fade-enter, .slide-down-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(50vh)
  }
</style>



// WEBPACK FOOTER //
// src/App.vue